var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins, Watch } from 'vue-property-decorator';
import CrudSidesheetMixin from '@/mixins/crud-sidesheet-mixin';
import BaseCrudSidesheet from '@/components/base/BaseCrudSidesheet.vue';
import UploadButton from '@/components/shared/UploadButton.vue';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import ItemsMixin from '@/mixins/items-mixin';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { TcnService } from '@/services/vendor-management/tcn-service';
import fileDownload from 'js-file-download';
var TcnUploadSidesheet = /** @class */ (function (_super) {
    __extends(TcnUploadSidesheet, _super);
    function TcnUploadSidesheet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept
        _this.supportedFileTypesList = [
            'application/vnd.ms-excel',
        ];
        _this.tcnFile = {};
        _this.tcnUploadSummary = {};
        _this.uploadVisible = false;
        return _this;
    }
    TcnUploadSidesheet.prototype.onVisibleChanged = function (val, oldVal) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(val && val !== oldVal && this.mode === 'upload-tcn')) return [3 /*break*/, 4];
                        // reset the file
                        this.tcnFile = {};
                        this.uploadVisible = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.tcnService.getLatestUploadSummary()];
                    case 2:
                        response = _a.sent();
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        if (response.success && response.data) {
                            this.tcnUploadSummary = response.data;
                        }
                        else {
                            this.tcnUploadSummary = {};
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this.showSnackbar({
                            text: 'Unable to get latest TCN upload summary',
                            color: 'error',
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TcnUploadSidesheet.prototype.upload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, summary, latestUploadResponse, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, 6, 7]);
                        return [4 /*yield*/, this.tcnService.uploadTcnDirectory(this.tcnFile)];
                    case 1:
                        response = _a.sent();
                        if (!(response.success === false)) return [3 /*break*/, 2];
                        this.showSnackbar({ text: response.message, color: 'error' });
                        return [2 /*return*/];
                    case 2:
                        summary = response.data;
                        this.showSnackbar({
                            // tslint:disable-next-line:max-line-length
                            text: summary.createdCount + " added, " + summary.updatedCount + " updated, " + summary.deletedCount + " deleted and " + summary.failedCount + " failed.",
                            color: 'success',
                        });
                        return [4 /*yield*/, this.tcnService.getLatestUploadSummary()];
                    case 3:
                        latestUploadResponse = _a.sent();
                        if (latestUploadResponse.success) {
                            this.tcnUploadSummary = latestUploadResponse.data;
                        }
                        // reset the file
                        this.tcnFile = {};
                        _a.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        error_2 = _a.sent();
                        console.error(error_2);
                        this.showSnackbar({
                            text: 'Unable to upload TCN directory',
                            color: 'error',
                        });
                        return [3 /*break*/, 7];
                    case 6:
                        // toggle the file upload, forces a reset
                        this.uploadVisible = false;
                        // update table with uploaded TCN data
                        this.$nextTick(function () { return __awaiter(_this, void 0, void 0, function () {
                            var getAllResponse, error_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.uploadVisible = true;
                                        this.sidesheetLoading = false;
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, 4, 5]);
                                        this.loading = true;
                                        return [4 /*yield*/, this.tcnService.getAll()];
                                    case 2:
                                        getAllResponse = _a.sent();
                                        if (getAllResponse.success) {
                                            this.items = getAllResponse.data;
                                        }
                                        else {
                                            throw new Error(getAllResponse.message);
                                        }
                                        return [3 /*break*/, 5];
                                    case 3:
                                        error_3 = _a.sent();
                                        console.error(error_3);
                                        console.error('Unable to load latest TCN records');
                                        this.showSnackbar({
                                            text: 'Unable to get latest TCN records. Please refresh and try again.',
                                            color: 'error',
                                        });
                                        return [3 /*break*/, 5];
                                    case 4:
                                        // reset loading indicator
                                        this.loading = false;
                                        return [7 /*endfinally*/];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    TcnUploadSidesheet.prototype.download = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.tcnService.getUploadSummaryFile(this.tcnUploadSummary.tcnUploadSummaryId)];
                    case 1:
                        response = _a.sent();
                        fileDownload(response, 'TcnUploadSummary.xlsx');
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.error(error_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TcnUploadSidesheet.prototype.clearAndClose = function () {
        // clear the file
        this.tcnFile = {};
        this.uploadVisible = false;
        this.close();
    };
    TcnUploadSidesheet.prototype.tcnFileChanged = function (file) {
        this.tcnFile = file;
    };
    TcnUploadSidesheet.prototype.getValidationRulesForField = function (name) {
        var rules = __assign({}, this.tcnService.getUploadValidationRules());
        return rules[name];
    };
    Object.defineProperty(TcnUploadSidesheet.prototype, "supportedFileTypes", {
        get: function () {
            return this.supportedFileTypesList.join(',');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TcnUploadSidesheet.prototype, "fileName", {
        get: function () {
            return this.tcnFile ? this.tcnFile.name : '';
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        lazyInject(TYPES.TcnService),
        __metadata("design:type", typeof (_a = typeof TcnService !== "undefined" && TcnService) === "function" ? _a : Object)
    ], TcnUploadSidesheet.prototype, "tcnService", void 0);
    __decorate([
        Watch('visible', { immediate: true, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Boolean]),
        __metadata("design:returntype", Promise)
    ], TcnUploadSidesheet.prototype, "onVisibleChanged", null);
    TcnUploadSidesheet = __decorate([
        Component({
            components: {
                'base-crud-sidesheet': BaseCrudSidesheet,
                'upload-btn': UploadButton,
            },
        })
    ], TcnUploadSidesheet);
    return TcnUploadSidesheet;
}(Mixins(CrudSidesheetMixin, ItemsMixin, SnackbarMixin)));
export default TcnUploadSidesheet;
